import React, { FC, ReactElement, useRef } from 'react';
import cns from 'classnames';
import Swiper from 'react-id-swiper';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '../../../Icon';
import { goNext, goPrev } from '../../../../helpers/swiper';
import './Program.sass';
import { getContentDataProgram } from '../../../../stores/reducers/userData';
import routes from '../../../../config/routes';
import { ParamsDto, internalizationState } from '../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../helpers/locale-field-finder';

interface Props {
  className?: string | Array<string>;
  bgSettings?: {
    color?: string;
    isDark?: boolean;
  };
  sectionName: string;
  sectionId: string;
  sectionData?: Array<ParamsDto>;
}

const Program: FC<Props> = ({ className, bgSettings, sectionName, sectionId, sectionData }): ReactElement => {
  const { backendURL, program, ...localeData } = useSelector(getContentDataProgram);
  const swiperRef = useRef(null);

  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    more_details_ru: 'Подробнее',
    more_details_en: 'More details',
  };

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const swiperParams = {
    watchOverflow: true,
    slidesPerView: 'auto' as 'auto',
    spaceBetween: 40,
  };

  const programBackground = sectionData!.find((param) => param.type === 'programBackgound');

  const replaceBrSpecial = (desc: string) => {
    return desc ? desc.replace(/!br!/gi, '<br/>') : '';
  }

  return (
    <section
      className={cns(
        'inner-section',
        bgSettings && bgSettings.isDark && 'inner-section--dark-bg',
        'program-section',
        className
      )}
      style={{ backgroundColor: bgSettings && bgSettings.color }}>
      <div className="container" id={sectionId}>
        <div className="inner-section__head">
          <div className="section-title">{sectionName}</div>
          <p className="user-fs-text">{localeFieldResolver(localeData, 'programSubtitle', activeLangState)}</p>
        </div>
        {program && (
          <div className="scroll-wrapper">
            <div className="st-slider">
              <Swiper ref={swiperRef} {...swiperParams}>
                {program.map((p: any, ind: any) => (
                  <div
                    key={ind}
                    className="swiper-slide st-slider-item"
                    style={{ backgroundColor: programBackground && programBackground.value }}>
                    <img src={`${backendURL}${p.image}`} alt="" />
                    <div className="st-slider-item__inner">
                      <div className="st-lider-item-tt primary-border-b f-heading">{localeFieldResolver(p, 'title', activeLangState)}</div>
                      <p className="user-fs-text" dangerouslySetInnerHTML={{ __html: replaceBrSpecial(localeFieldResolver(p, 'description', activeLangState)) }} />
                    </div>
                    {p.staticPageId && (
                      <Link className="btn btn-light btn--mobile-min" to={`${routes.STATIC}/${p.staticPageId}`}>
                        {localizedName('more_details_ru')}
                      </Link>
                    )}
                  </div>
                ))}
              </Swiper>
              {program.length > 3 && (
                <div className="slider-nav hidden-mobile">
                  <button className="slider-nav__prev" type="button" onClick={() => goPrev(swiperRef)}>
                    <Icon name="md-arr-left" />
                  </button>
                  <button className="slider-nav__next" type="button" onClick={() => goNext(swiperRef)}>
                    <Icon name="md-arr-right" />
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Program;
